import React from "react";
import { Empty } from "antd";
import { IoIosEyeOff, IoIosEye } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { MdOutlineEdit } from "react-icons/md";
import { ReactComponent as CheckedIcon } from "../assests/images/checked.svg";
import unCheckedIcon from "../assests/icons/uncheck.png";
import {
  accNoFormat,
  amountFormat,
  maskAmountFormat,
} from "../services/common.service";

export default function AccountListItem({
  dataSource,
  handleChange,
  setVisible,
  setSelectedDetails,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {dataSource.length === 0 && (
        <div style={{ marginTop: 20 }}>
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        </div>
      )}

      {dataSource.map((account, idx) => (
        <div key={idx}>
          <div
            className={
              account.checked ? "list-item selected-row-wrapper" : "list-item"
            }
            style={{ marginBottom: 10 }}
          >
            <div
              className={
                account.checked
                  ? "account-row-data selected-row list-row"
                  : "account-row-data list-row"
              }
              style={{ margin: 0, paddingLeft: 10 }}
            >
              <div className="list-row-display-item">
                <div>
                  {account.checked ? (
                    <CheckedIcon
                      className="checked"
                      onClick={() => handleChange(false, account)}
                      height={20}
                    />
                  ) : (
                    <img
                      onClick={() => handleChange(true, account)}
                      src={unCheckedIcon}
                      alt="unCheck"
                      height={20}
                      className="unchecked"
                    />
                  )}
                </div>
                <div>
                  <span className="d-flex justify-content-between">
                    <span
                      className="accNamespan acc-shortname"
                      title={
                        account?.acctShortName || account?.accountName || "-"
                      }
                    >
                      <span className="acc-shortname">
                        {account?.acctShortName || account?.accountName || "-"}
                      </span>
                      <MdOutlineEdit
                        onClick={() => {
                          setVisible(true);
                          setSelectedDetails(account);
                        }}
                        className="mx-2"
                        style={{ marginTop: "-5px", fontSize: 15 }}
                      />
                    </span>
                    {/* <MdOutlineEdit
                      onClick={() => {
                        setVisible(true);
                        setSelectedDetails(account);
                      }}
                      style={{ marginTop: "1px", fontSize: 15 }}
                    /> */}
                  </span>
                  <div className="list-item-heading hide-xs">
                    <span>
                      {account.accountType === "SA" &&
                        t("pages.my_accounts.casa.saving", {
                          defaultValue: "Saving",
                        })}
                      {account.accountType === "CA" &&
                        t("pages.my_accounts.casa.current", {
                          defaultValue: "Current",
                        })}
                      {account.accountType === "ODA" &&
                        t("pages.my_accounts.casa.over_draft", {
                          defaultValue: "Over Draft",
                        })}
                      {account.accountType === "FD" &&
                        t("pages.my_accounts.casa.term_depost", {
                          defaultValue: "Term Deposit",
                        })}
                      {account.accountType === "LA" &&
                        t("pages.my_accounts.casa.loan", {
                          defaultValue: "Investment",
                        })}
                      {account.accountType === "WA" &&
                        t("pages.Add_Bene.wallet", {
                          defaultValue: "Wallet",
                        })}
                    </span>
                  </div>
                  <div className="list-item-heading">
                    {accNoFormat(account)}
                  </div>

                  <div className="list-item-heading hide-xs">
                    {account.branchName || "-"}
                  </div>
                </div>
              </div>
              <div align="right">
                <label className="list-item-heading mx-2 hide-xs">
                  {t("pages.my_accounts.common_my_accounts.balance", {
                    defaultValue: "Balance",
                  })}
                </label>
                <div className="account-balance">
                  {amountFormat(account.avlBalance, account?.accountCurrency)}
                </div>
              </div>
            </div>
            <div
              className={
                account.checked
                  ? "sub-options sub-options-active "
                  : "sub-options"
              }
            >
              <span
                onClick={() =>
                  navigate("/accounts/summary", {
                    state: { ...account, key: "ACCOUNT_DETAILS " },
                  })
                }
              >
                {t("pages.my_accounts.common_my_accounts.ac_details", {
                  defaultValue: "A/c Details",
                })}
              </span>
              <span
                onClick={() =>
                  navigate("/accounts/summary", {
                    state: { ...account, key: "MINI_STATEMENT" },
                  })
                }
              >
                {t("navigation.statement", {
                  defaultValue: "Statement",
                })}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
